import { useEffect, useState } from 'react';
import {
    Typography, Box, Card, CardContent, CardActionArea, Grid, Chip, CircularProgress
} from '@mui/material';
import { getAllEmailTemplates } from '../../axios/axiosFunctions';
import EmailTemplateEditor from './EmailTemplateEditor';

const EmailTemplatesAdmin = () => {
    const [templates, setTemplates] = useState([]);
    const [selectedKey, setSelectedKey] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchTemplates = async () => {
        setLoading(true);
        const result = await getAllEmailTemplates();
        setTemplates(result?.templates || []);
        setLoading(false);
    };

    useEffect(() => {
        fetchTemplates();
    }, []);

    const handleBack = () => {
        setSelectedKey(null);
        fetchTemplates();
    };

    if (selectedKey) {
        return <EmailTemplateEditor templateKey={selectedKey} onBack={handleBack} />;
    }

    return (
        <Box>
            <Typography variant="h3" fontWeight={500} color="secondary" sx={{ mb: 2 }}>
                Email Templates
            </Typography>
            <Typography variant="body1" sx={{ color: '#666', mb: 4 }}>
                View and edit the email templates sent by the platform. Click on a template to customize it.
            </Typography>

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Grid container spacing={3}>
                    {templates.map((template) => (
                        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={template.templateKey}>
                            <Card
                                sx={{
                                    height: '100%',
                                    transition: 'box-shadow 0.2s',
                                    '&:hover': { boxShadow: 6 }
                                }}
                            >
                                <CardActionArea
                                    onClick={() => setSelectedKey(template.templateKey)}
                                    sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                                >
                                    <CardContent sx={{ width: '100%' }}>
                                        <Typography variant="h6" gutterBottom>
                                            {template.displayName}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                            {template.subject}
                                        </Typography>
                                        <Chip
                                            label={template.templateKey}
                                            size="small"
                                            variant="outlined"
                                            sx={{ mb: 1 }}
                                        />
                                        {template.updatedAt && (
                                            <Typography variant="caption" color="text.secondary" display="block">
                                                Updated: {new Date(template.updatedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
                                            </Typography>
                                        )}
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}
        </Box>
    );
};

export default EmailTemplatesAdmin;
